import { RefObject, useLayoutEffect, useState } from 'react'
import { useSize } from 'ahooks'

/**
 * Count the number of columns that can fit in the container.
 * Warning: It works only with "minmax" columns.
 */
export default function useCountGridColumns({
  target,
  minWidth,
  gap = 0,
}: {
  target?: RefObject<Element | null> | null
  minWidth?: number
  gap?: number
}) {
  const [count, setCount] = useState(0)
  const size = useSize(target ?? null)

  useLayoutEffect(() => {
    if (!size?.width || !minWidth) {
      return
    }
    const columnCount = Math.floor((size.width + gap) / (minWidth + gap))
    setCount(columnCount)
  }, [gap, minWidth, size])

  return {
    count,
    width: size?.width ?? 0,
    itemSize: count && size?.width ? (size.width - gap * (count - 1)) / count : 0,
  }
}
